import assign from 'lodash/assign';

const callbacks = {};

export function addCallbacks(objectWithNamedCallbacks) {
	assign(callbacks, objectWithNamedCallbacks);
}

export function addCallback(name, callback) {
	callback[name] = callback;
}

export function getCallback(name) {
	return name && callbacks[name];
}



// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables/src/callbacks.js